<script>
import {mapActions, mapGetters} from "vuex";
export default {
    name: "ShoppingListButton",
    props:{
        product: {
            type: Object,
            required: true
        }
    },
    computed:{
        ...mapGetters('shoppingList', ['shoppingListSKUs', 'enabled']),
        ...mapGetters(['lang']),
        isInList() {
            return this.shoppingListSKUs.includes(this.product?.sku);
        },
        tooltip() {
            return this.isInList? this.lang?.pdpRemoveFromList: this.lang?.pdpAddToList
        }
    },
    methods: {
        ...mapActions('shoppingList', ['addProductToList', 'removeProductFromList']),
        addToList(){
            this.addProductToList(this.product);
        },
        removeFromList(){
            this.removeProductFromList(this.product);
        },
        handleClick(){
            if(this.isInList){
                this.removeFromList();
            } else {
                this.addToList();
            }
        }
    }
}
</script>
<template>
    <div v-if="enabled" class="pdp-btn round shopping-list-btn" :class="`${isInList? 'in-list':''}`" @click="handleClick">
        <p v-if="isInList">  {{lang.pdpRaddarRemoveFromList}}</p>
        <p v-else>  {{lang.pdpRaddarAddToList}}</p>
      
    </div>
</template>
<style scoped lang="scss">
.pdp-modal {
    .pdp-btn.shopping-list-btn {

    cursor: pointer;
	background: #ede7ff;
	color: #552A94;
	
  &.in-list{
    // background-color: #E95B5B;
    .cls-1{
      stroke: #FFFFFF;
      &.sign{
        &.minus {
          display: none;
        }
      }
    }
  }
  .cls-1 {
    fill: none;
    stroke: currentColor;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 66.67px;
  }
}
}

</style>